/**
 * PullGameIncidentsQueryInfo defines properties and callbacks for the pull of gameIncidents endpoint of the sports data client.
 * @class SportDataGatewayQueryInfo
 */
var PullGameIncidentsQueryInfo = /** @class */ (function () {
    /* istanbul ignore next */
    function PullGameIncidentsQueryInfo(eventIds, onMessageHandler, onErrorHandler, incidentTypes, top, skip, format) {
        this.onMessageHandler = onMessageHandler;
        this.onErrorHandler = onErrorHandler;
        this.eventIds = eventIds;
        this.incidentTypes = incidentTypes;
        this.top = top;
        this.skip = skip;
        this.format = format;
    }
    return PullGameIncidentsQueryInfo;
}());
export { PullGameIncidentsQueryInfo };
//# sourceMappingURL=PullGameIncidentsQueryInfo.js.map